// extracted by mini-css-extract-plugin
export default {"delete":"_draggableStyles__delete","homeIcon":"_draggableStyles__homeIcon","navmenu-title":"_draggableStyles__navmenu-title","navmenu-icon":"_draggableStyles__navmenu-icon"};